import Modal from 'react-modal';
import { type IRatings, Ratings } from './components/Ratings';
import { CloseModalIcon } from '@icons/CloseModalIcon';
import { useDeviceType } from '../../hooks/useDeviceType';

interface IRatingsModal extends IRatings {
  modalIsOpen: boolean;
  setClose: () => void;
}

export const RatingsModal = ({
  ratingData,
  ratingMsg,
  settingRateData,
  trackingEvent,
  recipeTitle = '',
  showCommentField = false,
  showContactPageData = true,
  contactPageData,
  modalIsOpen,
  setClose,
}: IRatingsModal) => {
  const { isMobile } = useDeviceType();

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={setClose}
      className="sm:w-280 md:w-11/12 lg:w-790 outline-none content-center relative bg-white rounded-2xl text-center m-auto"
      overlayClassName="fixed top-0 right-0 bottom-0 left-0 z-[55] flex focus:outline-none bg-[#000000d9]"
      contentLabel="Rating Modal"
      ariaHideApp={false}
    >
      <Ratings
        ratingData={ratingData}
        ratingMsg={ratingMsg}
        settingRateData={settingRateData}
        trackingEvent={trackingEvent && trackingEvent}
        recipeTitle={recipeTitle}
        showCommentField={showCommentField}
        showContactPageData={showContactPageData}
        contactPageData={contactPageData}
      />
      <button
        className="cursor-default absolute md:top-5 md:right-5 sm:top-2.5 sm:right-2.5"
        onClick={setClose}
      >
        <CloseModalIcon height={isMobile ? 40 : 46} width={isMobile ? 40 : 46} />
      </button>
    </Modal>
  );
};
